export default "__VITE_ASSET__DstEqRAg__"